import { render, staticRenderFns } from "./Chat.htm?vue&type=template&id=30ca607b&scoped=true&"
import script from "./Chat.ts?vue&type=script&lang=js&"
export * from "./Chat.ts?vue&type=script&lang=js&"
import style0 from "./Chat.scss?vue&type=style&index=0&id=30ca607b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ca607b",
  null
  
)

export default component.exports